<template>
  <div>
    <!-- UPLOADED DOCUMENTS -->
    <div>
      <p class="font-weight-medium text-left">View or Upload Documents</p>
      <v-form>
        <v-container>
          <v-row>
            <!-- BIRTH CERTIFICATE -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Birth Certificate"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="ma-0 " text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>
            <!-- AADHAR CARD -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Aadhar Card"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>

            <!-- PAN CARD -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="PAN Card"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>

            <!-- RATION CARD -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Ration Card"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>

            <!-- DOMICILE CERTIFICATE -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Domicile Certificate"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>

            <!-- CASTE CAERTIFICATE -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Caste Certificate (If Applicable)"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>
            <!-- Previous Year Marksheet -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Previous Year Marksheet (If Applicable)"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>

            <!-- LEAVING CAERTIFICATE -->
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Leaving Certificate (If Applicable)"
                prepend-icon="mdi-paperclip"
                outlined
                class="my-0"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="text-right" text color="primary" outlined dense>
                View Document</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadedDocumentsStepperContent",
  data: () => ({
    files: []
  })
};
</script>

<style>
</style>